import gql from 'graphql-tag';

export const LOGIN_GQL = gql`
  query login($loginInput: LoginUserInput!) {
    login(loginInput: $loginInput) {
      token
      user {
        id
        userName
        nickName
        phone
      }
    }
  }
`;

export const GET_USERS_GQL = gql`
  query finAllUsers($userIds: [ID!]!) {
    users(userIds: $userIds) {
      id
      userName
      email
      nickName
    }
  }
`;

export const SEARCH_USERS_GQL = gql`
  query searchUser($keyword: String!) {
    searchUsers(keyword: $keyword) {
      id
      userName
      email
      nickName
    }
  }
`;

export const GET_SITES_GQL = gql`
  query finAll {
    sites {
      id
      siteName
      siteDomain
      createdAt
    }
  }
`;

export const GET_SITE_INFO_GQL = gql`
  query getSite($id: ID!) {
    site(id: $id) {
      id
      siteName
      siteDomain
      createdAt
    }

    rolesOfSites(siteIds: [$id]) {
      id
      siteId
      userId
      roleCode
    }
  }
`;

export const CREATE_SITE_GQL = gql`
  mutation createSite($createSiteInput: CreateSiteInput!) {
    createSite(createSiteInput: $createSiteInput) {
      id
      siteName
      siteDomain
    }
  }
`;

export const UPDATE_SITE_GQL = gql`
  mutation updateSite($updateSiteInput: UpdateSiteInput!) {
    updateSite(updateSiteInput: $updateSiteInput) {
      id
      siteName
      siteDomain
    }
  }
`;

export const GET_SITE_MODULES_GQL = gql`
  query getNodeTypes($siteId: ID!) {
    nodes(siteId: $siteId) {
      id
      parentId
      nodeName
      uniKey
      siteId
      type
    }
  }
`;
export const GET_NODE_ADD_DATA_GQL = gql`
  query getNodeTypes($siteId: ID!) {
    nodeTypes
    nodes(siteId: $siteId) {
      id
      parentId
      nodeName
      uniKey
      siteId
      type
    }
  }
`;

export const CREATE_NODE_GQL = gql`
  mutation createNode($createNodeInput: CreateNodeInput!) {
    createNode(createNodeInput: $createNodeInput) {
      id
      parentId
      nodeName
      siteId
      type
    }
  }
`;

export const UPDATE_NODE_GQL = gql`
  mutation createNode($updateNodeInput: UpdateNodeInput!) {
    updateNode(updateNodeInput: $updateNodeInput) {
      id
      parentId
      nodeName
      siteId
      type
    }
  }
`;

export const CREATE_ARTICLE_GQL = gql`
  mutation createArticle($createArticleInput: CreateArticleInput!) {
    createArticle(createArticleInput: $createArticleInput) {
      id
      siteId
      nodeId
      userId
      title
      content
      thumbUrl
      images
      author
      origin
      originUrl
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_ARTICLE_GQL = gql`
  mutation updateArticle($updateArticleInput: UpdateArticleInput!) {
    updateArticle(updateArticleInput: $updateArticleInput) {
      id
      siteId
      nodeId
      userId
      title
      content
      thumbUrl
      images
      author
      origin
      originUrl
      createdAt
      updatedAt
    }
  }
`;

export const GET_ARTICLES_GQL = gql`
  query articles($siteId: ID!, $nodeId: ID!, $keyword: String, $page: Int, $pageSize: Int, $orderBy: String, $order: String) {
    articleCount(siteId: $siteId, nodeId: $nodeId, keyword: $keyword)
    articles(siteId: $siteId, nodeId: $nodeId, keyword: $keyword, page: $page, pageSize: $pageSize, orderBy: $orderBy, order: $order) {
      id
      siteId
      nodeId
      userId
      title
      content
      thumbUrl
      images
      author
      origin
      originUrl
      viewCount
      createdAt
      updatedAt
    }
  }
`;

export const GET_TOP_ARTICLES_GQL = gql`
  query topArticles($nodeId: ID!) {
    topArticles(nodeId: $nodeId) {
      id
      siteId
      nodeId
      userId
      title
      content
      thumbUrl
      images
      author
      origin
      originUrl
      viewCount
      createdAt
      updatedAt
    }
  }
`;

export const GET_ARTICLE_GQL = gql`
  query article($id: ID!) {
    article(id: $id) {
      id
      siteId
      nodeId
      userId
      title
      content
      thumbUrl
      images
      author
      origin
      originUrl
      viewCount
      createdAt
      updatedAt
    }
  }
`;

export const GET_CURRENT_USER_GQL = gql`
  query getCurrentUser {
    currentRole {
      id
      userName
      email
      nickName
      isSystemAdmin
      isSuperAdmin
      isAdmin
    }
  }
`;

export const GET_ROLES_OF_SITES_GQL = gql`
  query getRolesOfSites($siteIds: [ID!]!) {
    rolesOfSites(siteIds: $siteIds) {
      id
      siteId
      userId
      roleCode
    }
  }
`;

export const CHECK_SITE_ADMIN_GQL = gql`
  query getRolesOfSites($siteId: ID!) {
    isSiteAdmin(siteId: $siteId) {
      isSiteAdmin
      isSiteSuperAdmin
    }
  }
`;

export const GET_SETTING_BY_BELONG_ID_GQL = gql`
  query getSettingByBelongId($belongId: ID!) {
    setting(belongId: $belongId) {
      id
      belongId
      values
    }
  }
`;

export const GET_SETTING_VALUES_BY_BELONG_ID_GQL = gql`
  query getSettingValuesByBelongId($belongId: ID!) {
    settingValues(belongId: $belongId) {
      id
      belongId
      values
    }
  }
`;

export const SAVE_SETTINGS_GQL = gql`
  mutation createSetting($createSettingInput: CreateSettingInput!) {
    createSetting(createSettingInput: $createSettingInput) {
      id
    }
  }
`;

export const SAVE_SETTING_VALUES_GQL = gql`
  mutation createSettingValues($createSettingValuesInput: CreateSettingValuesInput!) {
    createSettingValues(createSettingValuesInput: $createSettingValuesInput) {
      id
    }
  }
`;

export const GET_SETTING_DATA_GQL = gql`
  query getSettingData($belongId: ID!) {
    setting(belongId: $belongId) {
      id
      belongId
      values
    }

    settingValues(belongId: $belongId) {
      id
      belongId
      values
    }
  }
`;

export const GET_PAGE_CONTENT_GQL = gql`
  query getPageContent($nodeId: ID!) {
    page(nodeId: $nodeId) {
      id
      siteId
      nodeId
      title
      content
      thumbUrl
      images
      updatedAt
    }
  }
`;

export const SAVE_PAGE_CONTENT_GQL = gql`
  mutation savePage($savePageInput: SavePageInput!) {
    savePage(savePageInput: $savePageInput) {
      id
      siteId
      nodeId
      title
      content
      thumbUrl
      images
      updatedAt
    }
  }
`;

export const GET_MEDIAS_GQL = gql`
  query getMedias($nodeId: ID!, $keyword: String, $page: Int, $pageSize: Int, $orderBy: String, $order: String) {
    mediaCount(nodeId: $nodeId, keyword: $keyword)
    mediaList(nodeId: $nodeId, keyword: $keyword, page: $page, pageSize: $pageSize, orderBy: $orderBy, order: $order) {
      id
      siteId
      nodeId
      title
      mediaList
      content
      thumbUrl
      viewCount
      updatedAt
    }
  }
`;

export const GET_MEDIA_GQL = gql`
  query getMedia($id: ID!) {
    media(id: $id) {
      id
      siteId
      nodeId
      title
      mediaList
      content
      thumbUrl
      viewCount
      updatedAt
    }
  }
`;

export const CREATE_MEDIA_GQL = gql`
  mutation createMedia($createMediaInput: CreateMediaInput!) {
    createMedia(createMediaInput: $createMediaInput) {
      id
      siteId
      nodeId
      title
      mediaList
      content
      thumbUrl
    }
  }
`;

export const UPDATE_MEDIA_GQL = gql`
  mutation updateMedia($updateMediaInput: UpdateMediaInput!) {
    updateMedia(updateMediaInput: $updateMediaInput) {
      id
      siteId
      nodeId
      title
      mediaList
      content
      thumbUrl
    }
  }
`;

export const GET_CUSTOMIZED_FORM_LIST_GQL = gql`
  query getCustomizedFormList($nodeId: ID!, $page: Int, $pageSize: Int) {
    customizedCount(nodeId: $nodeId)
    customizedForms(nodeId: $nodeId, page: $page, pageSize: $pageSize) {
      id
      siteId
      nodeId
      values
    }
  }
`;

export const GET_CUSTOMIZED_FORM_GQL = gql`
  query getCustomizedForm($id: ID!) {
    customizedForm(id: $id) {
      id
      nodeId
      siteId
      values
    }
  }
`;

export const CREATE_CUSTOMIZED_FORM_DATA_GQL = gql`
  mutation createCustomizedForm($createCustomizedFormInput: CreateCustomizedFormInput!) {
    createCustomizedForm(createCustomizedFormInput: $createCustomizedFormInput) {
      id
    }
  }
`;

export const UPDATE_CUSTOMIZED_FORM_DATA_GQL = gql`
  mutation updateCustomizedForm($updateCustomizedFormInput: UpdateCustomizedFormInput!) {
    updateCustomizedForm(updateCustomizedFormInput: $updateCustomizedFormInput) {
      id
    }
  }
`;
